import React from 'react';
import './projects.css';
import { Navbar, Header, Footer } from '../../components';

import wasteImage from '../../assets/waste-classifier.jpg';
import diagnosisImage from '../../assets/ai-health-diagnosis.jpg';

const projects = [
  {
    title: 'AI Waste Classifier',
    image: wasteImage,
    content: `
Overview:  
The Waste Classification App is an AI-powered tool that uses computer vision to identify and categorize different types of waste — including plastic, paper, glass, metal, and organic materials. Designed to support smart recycling systems, it encourages efficient waste segregation practices at household and community levels.

Tech Stack:  
TensorFlow / Keras, Python, FastAPI, React, CNN (Convolutional Neural Networks), OpenCV

Features:  
- Upload image of waste for real-time classification  
- Multi-class CNN trained on a custom-labeled waste dataset  
- Integrated into a full-stack web app (FastAPI + React)  
- Scalable for deployment in smart bins or mobile recycling units  

My Role:  
I designed the CNN architecture, built and trained the model, developed the backend with FastAPI, and implemented the frontend in React. I also curated and annotated the dataset and led full-stack integration.
Impact:  
Contributes to SDG 11 (Sustainable Cities) and SDG 13 (Climate Action) by enhancing waste management, especially in urban areas of developing regions.

Status:  
AI model built and trained using google colab, functional frontend and backend pipeline in development and will soon be deployed.
    `.trim(),
    github: 'https://github.com/GoodnessOno/WASTE-CLASSIFIER-AI',
    tags: ['AI', 'Sustainability'],
  },
  {
    title: 'AI Disease Diagnosis',
    image: diagnosisImage,
    content: `
Overview:  
This project involves building a deep learning model for medical diagnosis, trained to predict potential illnesses based on patient symptom data or diagnostic imagery. It aims to offer low-cost, early diagnostic support in low-resource environments.

Tech Stack:  
Python, TensorFlow / Keras, Pandas, Scikit-learn, Jupyter Notebook

Features:  
- Supervised learning model trained on medical datasets  
- Predicts diseases based on symptoms or diagnostic input  
- Evaluated using accuracy, precision, recall, and F1-score  
- Designed for future integration into telemedicine platforms  

My Role:  
I handled data collection and cleaning, model design and training, and performance evaluation. I also explored options for deploying the model via an API using FastAPI or Flask.

Impact:  
Supports SDG 3 (Good Health and Well-being) by enabling early-stage diagnosis and health equity through AI.

Status:  
Model is fully trained and validated. Web deployment planning in progress.
    `.trim(),
    github: 'https://github.com/GoodnessOno/MEDICAL-AI-MODEL',
    tags: ['AI', 'Health'],
  },
];

const Projects = () => {
  return (
    <div>
      <Navbar />
      <main id="page-content" tabIndex="-1">
        <Header />
        <section className="project-section">
          <h2 className="section-title">Projects — Infrastructure × Intelligence</h2>
          <div className="project-grid">
          {projects.map((project, idx) => (
            <div className="project-box" key={idx}>
              <img src={project.image} alt={project.title} className="project-img" />
              <div className="project-info">
                <h2>{project.title}</h2>
                {project.content.split('\n').map((line, i) => (
                  <p key={i}>{line.trim()}</p>
                ))}
                <div className="project-tags">
                  {project.tags.map((tag, i) => (
                    <span className="tag" key={i}>{tag}</span>
                  ))}
                  {project.github && (
                    <a href={project.github} target="_blank" rel="noopener noreferrer" className="github-link">
                        View on GitHub
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      </main>
      <Footer />
    </div>
  );
};

export default Projects;
